import { createFileRoute } from "@tanstack/react-router";
import { PublicBookingPage } from "@/features/public-booking/PublicBookingPage";
import { parseBookingSearch, utmFromSearch } from "@/features/public-booking/search-params";

// ?ma= là mã người giới thiệu đem đi rải; utm_* là tham số đo kênh đi kèm
// link (spec 2026-08-20); ?sdt= là số điện thoại điền sẵn khi khách bấm
// "Đặt chụp tiếp" từ cổng khách. Parse chung ở search-params.ts cho cả 2 route.
export const Route = createFileRoute("/booking/")({
  validateSearch: parseBookingSearch,
  component: BookingIndexRoute,
});

function BookingIndexRoute() {
  const search = Route.useSearch();
  const utm = utmFromSearch(search);
  return (
    <PublicBookingPage
      {...(search.ma ? { initialPromoCode: search.ma } : {})}
      {...(search.affDauMay ? { initialAffDauMay: search.affDauMay } : {})}
      {...(search.sdt ? { initialPhone: search.sdt } : {})}
      {...(utm ? { initialUtm: utm } : {})}
    />
  );
}
